// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-view .loading-component[data-v-3fa1591a]{border-radius:6px}.settings-view .card-component__content>.row-component[data-v-3fa1591a]{margin-bottom:20px}.settings-view .card-component__content>.row-component[data-v-3fa1591a]:last-of-type{margin-bottom:0}.settings-view .preview-component__options>.row-component[data-v-3fa1591a]{height:28px;margin-bottom:20px}.settings-view .preview-component__options>.row-component[data-v-3fa1591a]:last-of-type{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
